
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import VuePicker from 'vue-pickers'
import { AppModule, DeviceType } from '@/store/modules/app'
import { TicketsModule } from '@/store/modules/tickets'
import { ORDERAPI } from '@/api/orders'
import { CONFIGAPI } from '@/api/config'
import { ConfigModule } from '../../../store/modules/config'
import { isAgentMobile } from '@/utils/validate'
import { getuserCurrentApp } from '@/utils/cookies'
import { isAdministrationTicketType, isItTicketType, isLiveType, isNetworkTicketType } from '@/utils/commonFunc'
import { problemList } from '@/utils/consts'

interface IFormdata {
  append_describe: string;
  is_live_influenced: number;
  solution: string;
  issue_type: string | Array<string>;
  computer_type: string;
  is_official: number;
  belong_to_dept: string;
  problem_attr: string;
  solution_type: string;
  strategy: string | Array<string>;
}

const defaultRole: IFormdata = {
  append_describe: '',
  is_live_influenced: 0,
  solution: '',
  issue_type: [],
  computer_type: '',
  is_official: 0,
  belong_to_dept: '1',
  problem_attr: '1',
  solution_type: '',
  strategy: []
}

@Component({
  name: 'FinishedDialog',
  components: {
    VuePicker
  }
})
export default class extends Vue {
  @Prop({ default: 0 }) private tid!: number
  @Prop({ default: 0 }) private ticketType!: number
  handleIssueTypeChange(value: any) {
    interface IssueType {
      id: number;
      label: string;
      describe: string;
      solution: string;
      switchValue: boolean;
      parent_id: number;
      children?: IssueType[];
    }

    // 根据选择的问题类型，自动填充问题描述和解决方案
    // 这里可以根据 value 来获取对应的问题描述和解决方案，然后赋值给 formData
    // 示例中直接赋值为空字符串，你需要替换为实际逻辑
    // 根据选择的问题类型，自动填充问题描述和解决方案
    // 遍历 issueTypeOptions 数组查找目标对象
    const issueTypeOptions: IssueType[] = this.issueTypeOptions
    for (const option of issueTypeOptions) {
      if (option.children) {
        const child = option.children.find(child => child.id === value[value.length - 1])
        if (child && child.switchValue) {
          // 找到并启用了 switchValue，拼接 solution
          this.finishedForm.solution = (this.finishedForm.solution || '' ) + child.solution
          break // 找到后就跳出循环
        } else if (child) {
          // 找到但 switchValue 为 false，也拼接（不清空）
          this.finishedForm.solution = (this.finishedForm.solution || '') + child.solution
        }
      }
    }
  }

  handleStrategyChange(val: any) {
    const selected = this.strategyOptions.find(item => item.id === val)
    if (selected) {
      this.finishedForm.solution = this.finishedForm.solution.concat(selected.name) || ''
    } else {
      this.finishedForm.solution = ''
    }
  }

  private finishedForm = Object.assign({}, defaultRole)
  private rules = {
    is_live_influenced: [{ required: true, message: '请选择是否影响直播', trigger: 'change' }],
    append_describe: [{ required: true, message: '请输入问题补充描述', trigger: 'blur' }],
    solution: [{ required: true, message: '请输入解决方案', trigger: 'blur' }],
    issue_type: [{ required: true, message: `${this.isNetworkTicketType ? '请选择问题源' : '请选择问题类型'}`, trigger: 'change' }],
    computer_type: [{ required: true, message: '请选择笔记本型号', trigger: 'change' }],
    belong_to_dept: [{ required: true, message: '是否归属直播保障', trigger: 'change' }],
    problem_attr: [{ required: true, message: '请选择问题原因归属', trigger: 'change' }],
    solution_type: [{ required: true, message: '请选择解决方式', trigger: 'change' }]
  }

  private btnLoading = false

  private computerTypeOptions = [] // 笔记本型号options
  private issueTypeOptions = [] // 问题类型options
  private strategyOptions: Array<{ id: number; name: string }> = []
  private pickerIssueVisible = false // 点击问题类型文本框，显示picker联动
  private pickerStrategyVisible = false // 点击问题类型文本框，显示picker联动

  private issueTypeCn = '' // 移动端：问题类型内容
  private strategyCn = '' // 移动端：问题类型内容

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get isItTicketType() {
    return isItTicketType()
  }

  get isLiveType() {
    return isLiveType()
  }

  get isNetworkTicketType() {
    return isNetworkTicketType()
  }

  get isAdministrationTicketType() {
    return isAdministrationTicketType()
  }

  get problemList() {
    return problemList
  }

  get dialogVisible() {
    return TicketsModule.finishedDialog
  }

  get currentTicket() {
    return TicketsModule.currentTicket
  }

  get device() {
    return AppModule.device
  }

  get isMobile() {
    return this.device === DeviceType.Mobile
  }

  get isAgentMobile() {
    return isAgentMobile()
  }

  @Watch('dialogVisible')
  private onDialogStatusChange(value: boolean) {
    if (value) { // 打开弹框
      this.finishedForm = Object.assign({}, defaultRole)
      this.issueTypeCn = ''
      this.$nextTick(() => {
        if (this.$refs.finishedForm) {
          (this.$refs.finishedForm as any).clearValidate()
        }
      })
      this.getTutorIssueType() // 获取班主任问题类型列表
      if (this.isItTicketType) {
        this.getComputerType() // 获取笔记本型号
      }
      if (this.isAdministrationTicketType) {
        const place_id = this.currentTicket.location.place_id.split('_')[1]
        this.getStrategy(place_id)
      }
    }
  }

  // 关闭弹框
  private handleClose() {
    // (this.$refs.blurSelect as any).blur()
    TicketsModule.ToggleDialogStatus({
      name: 'finishedDialog',
      value: false
    })
  }

  // 提交
  private handleSubmit() {
    const form: any = this.$refs.finishedForm
    form.validate(async (valid: boolean) => {
      if (valid) {
        this.btnLoading = true
        const postData = {
          tid: this.currentTicket.tid,
          t_type: this.currentTicket.ticket_type,
          append_describe: this.finishedForm.append_describe,
          issue_type: this.finishedForm.issue_type[1],
          computer_type: this.finishedForm.computer_type,
          solution: this.finishedForm.solution,
          is_live_influenced: this.finishedForm.is_live_influenced,
          is_official: this.finishedForm.is_official,
          belong_to_dept: this.finishedForm.belong_to_dept,
          problem_attr: this.finishedForm.problem_attr,
          solution_type: this.finishedForm.solution_type
        }
        ORDERAPI.finishedTicket(postData, { app_id: this.userCurrentApp })
          .then((res: any) => {
            this.$emit('handleSuccess', res)
            this.btnLoading = false
            this.handleClose()
          }).catch(() => {
            this.btnLoading = false
          })
      } else {
        return false
      }
    })
  }

  // 移动端：问题类型联动确认
  confirmChangeIssue(res: any) {
    const issueType: string[] = []
    res.map((item: { label: string }) => {
      issueType.push(item.label)
    })
    this.issueTypeCn = issueType.join('/')
    this.finishedForm.issue_type = [res[0].id, res[1].id]
  }

  confirmChangeStrategy(res: any) {
    const issueType: string[] = []
    res.map((item: { label: string }) => {
      issueType.push(item.label)
    })
    this.issueTypeCn = issueType.join('/')
    this.finishedForm.issue_type = [res[0].id, res[1].id]
  }

  // 获取问题类型
  private async getTutorIssueType() {
    const options = ConfigModule.issueTypeOptions
    if (options.length <= 0) { // 仅首次打开时请求
      const { data } = await CONFIGAPI.getIssuesType({ app_id: this.userCurrentApp })
      const newData: any = []
      // 删掉掉没有基地的地区
      data.map((item: any) => {
        if (item.children && item.children.length !== 0) {
          newData.push(item)
        }
      })
      this.issueTypeOptions = newData
      ConfigModule.setIssueTypeOptions(newData)
    } else {
      this.issueTypeOptions = options
    }
  }

  // 笔记本型号
  private async getComputerType() {
    const options = ConfigModule.computerTypeOptions
    if (options.length <= 0) { // 仅首次打开时请求
      const { data } = await CONFIGAPI.getComputerType({
        is_paged: 0,
        app_id: this.userCurrentApp
      })
      this.computerTypeOptions = data.lists
      ConfigModule.setComputerTypeOptions(data.lists)
    } else {
      this.computerTypeOptions = options
    }
  }

  // 笔记本型号
  private async getStrategy(place_id: any) {
    const options = ConfigModule.strategyOptions

    if (options.length <= 0) { // 仅首次打开时请求
      const { data } = await CONFIGAPI.getStrategyData({
        is_paged: 0,
        app_id: this.userCurrentApp,
        place: place_id
      })

      // 过滤掉 status = 0 的项
      const filteredList = data.lists.filter((item: any) => item.status !== 0)

      this.strategyOptions = filteredList
      ConfigModule.setStrategyOptions(filteredList)
    } else {
      // 这里也要过滤一次，防止旧数据有 status=0 的残留
      this.strategyOptions = options.filter((item: any) => item.status !== 0)
    }
  }
}
